import axios from 'axios';
import { SERVER_AUTH } from '../utils/baseUrl';

const ENDPOINT_LOGIN = `${SERVER_AUTH}/v1/login`;
const ENDPOINT_REFRESH_TOKEN = `${SERVER_AUTH}/v1/login/refresh-token`;

const httpAuth = axios.create({
    baseURL: SERVER_AUTH
});

httpAuth.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token && config.url !== ENDPOINT_LOGIN && config.url !== ENDPOINT_REFRESH_TOKEN) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

httpAuth.interceptors.response.use((response) => response,
    async (error) => {
        const originalRequest = error.config;
        const refreshToken = localStorage.getItem('refresh_token');
        if (error.response?.status === 401 && !originalRequest._retry && error.config?.url !== ENDPOINT_REFRESH_TOKEN) {
            originalRequest._retry = true;
            if (refreshToken) {
                try {
                    const response = await httpAuth.post(ENDPOINT_REFRESH_TOKEN, { refreshToken }, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    });
                    localStorage.setItem('access_token', response.data.access_token);
                    localStorage.setItem('refresh_token', response.data.refresh_token);
                    if (response.data.access_token) {
                        httpAuth.defaults.headers.common.Authorization = `Bearer ${response.data.access_token}`;
                    }
                    return httpAuth(originalRequest);
                } catch (e) {
                    if ((e.response?.status === 400 || e.response?.status === 401 || e.response?.status === 500) && e.config?.url === ENDPOINT_REFRESH_TOKEN) {
                        localStorage.removeItem('access_token');
                        localStorage.removeItem('refresh_token');
                        window.location.href = '/';
                    }
                    return Promise.reject(e);
                }
            }
        } else if (error.response?.status === 401 && originalRequest._retry && error.config?.url === ENDPOINT_REFRESH_TOKEN) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            window.location.href = '/';
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default httpAuth;
